module.exports = __webpack_public_path__ + "img/user_voice.3c48adef.svg";